/**
 * StreamStatusInputDTO entity class
 */

/**
 * StreamStatusInputDTOFactory
 * returns StreamStatusInputDTO entity class
 *
 * @class StreamStatusInputDTOFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.StreamStatusInputDTO} class
 *
 * @ngdoc factory
 * @name mwApp.factory:StreamStatusInputDTOFactory
 */
/* @ngInject */
export default function StreamStatusInputDTOFactory (Entity) {
  /* === StreamStatusInputDTO class === */

  /**
   * StreamStatusInputDTO model
   *
   * @class StreamStatusInputDTO
   * @classdesc StreamStatusInputDTO model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @param {Object} [object] - initial object, containing StreamStatusInputDTO entity fields
   * @return {models.StreamStatusInputDTO} StreamStatusInputDTO entity
   */
  function StreamStatusInputDTO () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  StreamStatusInputDTO.prototype = Object.create(Entity.prototype)
  StreamStatusInputDTO.prototype.constructor = StreamStatusInputDTO

  /* === StreamStatusInputDTO instance methods & fields === */

  Object.assign(StreamStatusInputDTO.prototype, {

    /**
     * instance fields
     *
     * @memberof models.StreamStatusInputDTO#
     * @type {Object}
     */
    _fields: {
      externalId: String,
      bytesPerSecondRate: Number
    }
  })

  /**/

  /* === StreamStatusInputDTO static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(StreamStatusInputDTO, Entity)
  StreamStatusInputDTO._name = 'StreamStatusInputDTO'
  StreamStatusInputDTO.init()

  return StreamStatusInputDTO
}
